"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrify = arrify;
exports.arrifyFields = arrifyFields;
const real_type_of_1 = require("./real-type-of");
function arrify(value, treatNullAsEmpty = true) {
    if (value === undefined || value === null)
        return treatNullAsEmpty ? [] : value;
    if ((0, real_type_of_1.isArray)(value))
        return value;
    return [value];
}
function arrifyFields(obj, schema = {}) {
    if (!(0, real_type_of_1.isObject)(obj)) {
        return obj;
    }
    if (!schema.properties)
        return obj;
    for (const key of Object.keys(obj)) {
        const fieldSchema = schema.properties[key];
        if (!fieldSchema)
            continue;
        if (fieldSchema.type === 'array') {
            obj[key] = arrify(obj[key], false);
        }
    }
    return obj;
}
//# sourceMappingURL=arrify.js.map